import React from "react";
import { Input, InputProps, InputRef } from "antd";
import { NumberFormatValues, NumericFormat, NumericFormatProps } from "react-number-format";

export type CustomNumericFormatProps = Omit<NumericFormatProps, "onChange"> &
  Omit<InputProps, "onChange"> & { onChange?: (value?: number) => void };

const CustomNumericFormat = React.forwardRef<InputRef, CustomNumericFormatProps>(function CustomNumericFormat({ onChange, ...rest }, ref) {
  return (
    <NumericFormat
      {...rest}
      getInputRef={ref ?? rest.getInputRef}
      onValueChange={(values: NumberFormatValues) => {
        if (onChange && rest.value !== values.floatValue) {
          onChange(values.floatValue);
        }
      }}
      customInput={Input}
      autoComplete="off"
    />
  );
});

export const StringCustomNumericFormat = React.forwardRef<
  InputRef,
  Omit<NumericFormatProps, "onChange"> & Omit<InputProps, "onChange"> & { onChange?: (value?: string) => void }
>(function StringCustomNumericFormat({ onChange, ...rest }, ref) {
  return (
    <NumericFormat
      {...rest}
      getInputRef={ref ?? rest.getInputRef}
      onValueChange={(values: NumberFormatValues) => {
        if (onChange && rest.value !== values.formattedValue) {
          onChange(values.formattedValue);
        }
      }}
      customInput={Input}
      autoComplete="off"
    />
  );
});

export default CustomNumericFormat;
